<template>
  <div class="reports">
    <h1 class="reports__title">Заказанные товары</h1>
    <div class="reports__group">
      За период<template v-if="isMobile">:</template> <template v-if="!isMobile">с</template>
      <span>
        <date-picker
          v-model="dateFrom"
          valueType="YYYY-MM-DD HH:mm:ss"
          format="DD.MM.YYYY"
          class="reports__datepicker">
        </date-picker>
        <template v-if="!isMobile">по</template>
        <date-picker
          v-model="dateTo"
          valueType="YYYY-MM-DD HH:mm:ss"
          format="DD.MM.YYYY"
          class="reports__datepicker">
        </date-picker>
      </span>
      <div v-if="!dateFrom || !dateTo" class="reports__error">Укажите обе даты</div>
    </div>

    <div class="reports__buttons">
      <BaseBtn
        @btnClick="sendReports"
        :text="'Сформировать отчет'"
        class="reports__add" />
      <a
        v-if="reports && reports.length > 0"
        :href="excelLink"
        class="reports__exel">
        <img src="/img/xls_new.svg" alt="" title="" />
        Скачать отчет
      </a>
    </div>

    <List
      v-if="reports"
      :reports="reports" />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import moment from 'moment';

export default {
  components: {
    BaseBtn: () => import('@/components/base/BaseBtn'),
    List: () => import('./components/List'),
  },

  metaInfo() {
    return {
      title: `Заказанные товары - Личный кабинет дилера - ${this.getDealerName}`,
    }
  },

  data: () => ({
    dateTo: null,
    dateFrom: null,
    showError: false,
    excelLink: '',
  }),

  computed: {
    ...mapState({
      reports: state => state.account.reports,
    }),


    ...mapGetters('user', [
      'getDealerName',
    ]),
  },

  methods: {
    ...mapActions('account', [
      'setReports',
    ]),

    ...mapActions('account/orders', [
      'setStatusList',
    ]),

    sendReports() {
      if (!this.dateTo || !this.dateFrom) return;
      this.togglePreload();
      const date_from = moment(this.dateFrom).format('DD.MM.YYYY');
      const date_to = moment(this.dateTo).format('DD.MM.YYYY');
      this.setReports({
        date_from,
        date_to,
      }).finally(() => {
        this.excelLink += `/account/reports/generate-excel?date_from=${date_from}&date_to=${date_to}`;
        this.togglePreload();
      });
    },
  },

  created() {
    this.dateFrom = moment().subtract(3, 'month').format('YYYY-MM-DD HH:mm:ss');
    this.dateTo = moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss');
    this.setStatusList();
  },

  beforeDestroy() {
    this.dateFrom = null;
    this.dateTo = null;
    this.showError == false;
  },
}
</script>

<style scoped lang="scss">
  .reports {
    padding-bottom: 40px;

    &__sub {
      li {
        display: flex;
        flex-direction: row;
        border-bottom: 1px solid #000;

        &:last-child {
          border-bottom: none;
        }
      }

      &--height {
        li {
          height: 100%;
        }
      }
    }

    &__datepicker {
      margin: 0 5px;

      @media(max-width: $desktop) {
        margin: 2px 0 0;
        width: 50%;

        &:first-child {
          margin-right: 21px;
        }
      }
    }

    &__error {
      position: absolute;
      width: 100%;
      top: 100%;
      padding-top: 10px;
      font-size: 12px;
      line-height: 12px;
      color: #FF3B3B;
    }

    &__title {
      font-weight: bold;
      font-size: 24px;
      line-height: 30px;
      position: fixed;
      z-index: 120;
      left: 50%;
      transform: translateX(-50%);
      top: 0;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      height: 53px;
      margin: 0;

      @media(max-width: $desktop) {
        position: static;
        height: auto;
        transform: translateX(0);
        margin-bottom: 20px;
        order: 1;
        z-index: 1;
      }
    }

    &__group {
      text-align: center;
      margin-bottom: 30px;
      position: relative;

      @media(max-width: $desktop) {
        font-size: 14px;
        line-height: 18px;
        color: #979797;
        text-align: left;

        span {
          display: flex;
          flex-direction: row;
          width: 100%;
        }
      }
    }

    &__buttons {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin-bottom: 30px;

      @media(max-width: $desktop) {
        flex-direction: column;
      }
    }

    &__add {
      margin: 0;

      @media(max-width: $desktop) {
        width: 100%;
        max-width: 334px;
      }
    }

    &__exel {
      display: flex;
      flex-direction: row;
      align-items: center;
      color: #539fbb;
      margin-left: 20px;
      font-size: 14px;
      line-height: 16px;

      @media(max-width: $desktop) {
        margin-left: 0;
        margin-top: 20px;
      }

      img {
        width: 25px;
        height: auto;
        margin-right: 5px;
      }
    }
  }
</style>
